<template>
  <div class="page__header">
    <div class="bc--secondary pt3 pb2">
      <div class="row--evenly mh4">
        <div class="row--start">
          <div
            @click="cancel"
            class="label label--secondary column--central"
          >
            <div class="row--central">
              <font-awesome-icon :icon="['fas', 'undo-alt']" />
              <div class="ml1">
                返回
              </div>
            </div>
          </div>
        </div>
        <div class="column--central fc--primary">
          {{ setting.title }}
        </div>
        <div class="row--end">
          <div
            @click="$router.push({path: '/home'})"
            class="label label--secondary column--central"
          >
            <font-awesome-icon :icon="['fas', 'home']" />
          </div>
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/curve-header.png"
      alt=""
    >
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  props: {
    setting: {
      type: Object,
      default() {
        return {
          title: '璟馨婦幼醫院',
          hasCancelMethod: false,
        };
      },
    },
  },
  emits: [
    'cancel',
  ],

  setup(props, { emit }) {
    const router = useRouter();

    function cancel() {
      if (props.setting.hasCancelMethod) {
        emit('cancel');
      } else {
        router.back();
      }
    }

    return {
      cancel,
    };
  },
};
</script>
